<div class="usc-wrapper">

  <!-- SECCIÓN SUPERIOR: encabezado -->
  <div class="usc-header">
    <button class="usc-close" (click)="confirm()">&#x2715;</button>
  </div>

  <!-- Icono superpuesto entre las dos secciones -->
  <div class="usc-icon-wrapper">
    <div class="usc-icon">
      <img src="assets/img/modals/unsaved-changes/Formulario_icono.png" alt="Formulario completado" />
    </div>
  </div>

  <!-- SECCIÓN INFERIOR: contenido -->
  <div class="usc-body">
    <h2 class="usc-title">{{ title }}</h2>
    @if (description) {
      <p class="usc-desc">{{ description }}</p>
    }

    <div class="usc-actions">
      <button class="usc-btn usc-btn--filled" (click)="confirm()">Entendido</button>
    </div>
  </div>

</div>
